import { useContext } from 'react';
import { useUserHasFeature } from 'src/hooks/useUserHasFeature';
import { useUserHasConsignorMasterUI } from 'src/hooks/useUserIsConsignorMasterUI';
import { Feature } from 'src/WebApiController';
import { useContext as useContextWithSelector } from 'use-context-selector';

import {
  catalogMetricsContextWithSelector,
  catalogMetricsEmptyContextWithSelector,
  createCatalogMetricsContextV2,
  createCatalogMetricsEmptyContext,
} from './CatalogMetrics.type';

export function useCatalogMetricsContext<
  TMetrics extends { currency: string | null },
>() {
  const hasCatalogDataContextWithSelectorFeature = useUserHasFeature(
    Feature.FEPerf_CatalogDataContextWithSelector
  );
  const isConsignorMasterView = useUserHasConsignorMasterUI();

  const context = useContext(
    isConsignorMasterView
      ? createCatalogMetricsEmptyContext<TMetrics>()
      : createCatalogMetricsContextV2<TMetrics>()
  );

  const contextWithSelector = useContextWithSelector(
    isConsignorMasterView
      ? catalogMetricsEmptyContextWithSelector<TMetrics>()
      : catalogMetricsContextWithSelector<TMetrics>()
  );

  return hasCatalogDataContextWithSelectorFeature
    ? contextWithSelector
    : context;
}
